var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _g2, _g3, _g4, _g5, _g6, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 137,
    viewBox: "0 0 185 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.965 126.186C166.473 124.311 166.421 122.352 165.601 120.537C164.43 117.946 162.022 116.183 160.043 114.146C158.065 112.109 156.379 109.258 157.219 106.544C158.182 103.427 161.826 102.177 164.989 101.37C168.146 100.563 171.797 99.3265 172.779 96.2156C173.443 94.1135 172.584 91.7966 171.276 90.0199C169.968 88.2431 168.243 86.8179 166.831 85.1257C165.419 83.4336 164.286 81.2989 164.547 79.1122C165.1 74.4719 171.628 74.4914 174.563 72.1745C178.747 68.8749 175.292 63.1152 176.034 58.8719C176.444 56.5094 178.11 54.583 179.789 52.8779C181.474 51.1727 183.297 49.4871 184.201 47.2678C187.631 38.8268 174.439 30.9454 168.217 37.2583C165.126 40.4017 163.863 47.1246 158.995 48.0228C154.069 48.9404 147.163 44.4042 142.998 48.8428C140.623 51.3745 141.547 55.4551 142.796 58.6896C144.046 61.9307 145.452 65.6924 143.695 68.6927C139.881 75.2073 127.815 69.5322 125.752 77.752C124.971 80.8824 126.11 84.1235 126.91 87.2474C127.711 90.3713 128.062 94.0159 126.051 96.528C123.708 99.4567 119.302 99.5283 116.08 101.455C111.57 104.149 110.086 110.358 111.642 115.376C113.197 120.393 117.167 124.318 121.502 127.286C131.023 133.8 147.892 139.293 159.125 134.119C162.373 132.622 165.067 129.544 165.972 126.192L165.965 126.186Z",
    fill: "url(#paint0_linear_17594_63343)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M179.144 51.616C177.146 53.243 175.135 55.1108 174.302 57.5709C172.805 61.9965 175.272 68.4656 170.475 71.5179C167.111 73.6591 160.531 72.9497 159.158 77.8113C158.507 80.1086 159.275 82.4841 160.401 84.43C161.527 86.376 163.017 88.0681 164.019 90.0921C165.022 92.1162 165.484 94.6609 164.442 96.8216C162.906 100.011 159.008 100.941 155.682 101.455C152.357 101.976 148.458 102.913 146.942 106.115C145.621 108.907 146.812 112.109 148.452 114.478C150.085 116.847 152.207 118.975 152.923 121.845C153.43 123.863 153.138 125.946 152.292 127.878C150.788 131.341 147.528 134.315 143.994 135.558C143.785 135.63 143.577 135.688 143.369 135.753C148.966 136.547 154.511 136.222 159.112 134.1C162.36 132.603 165.054 129.525 165.959 126.173C166.466 124.299 166.414 122.34 165.594 120.524C164.423 117.934 162.015 116.17 160.036 114.133C158.058 112.096 156.372 109.246 157.212 106.532C158.175 103.414 161.82 102.165 164.982 101.358C168.139 100.551 171.79 99.3142 172.773 96.2033C173.437 94.1012 172.577 91.7843 171.269 90.0075C169.961 88.2308 168.237 86.8055 166.824 85.1134C165.412 83.4213 164.28 81.2866 164.54 79.0999C165.093 74.4596 171.621 74.4791 174.556 72.1622C178.741 68.8626 175.285 63.1028 176.027 58.8595C176.437 56.4971 178.103 54.5707 179.782 52.8655C181.468 51.1604 183.29 49.4748 184.195 47.2555C184.338 46.9041 184.442 46.5526 184.526 46.2012C183.225 48.4205 181.116 50.0019 179.138 51.6094L179.144 51.616Z",
    fill: "url(#paint1_linear_17594_63343)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.11 131.178C135.501 122.828 136.867 114.51 139.022 106.401C139.594 104.384 140.154 102.36 140.759 100.355L142.751 94.3872L144.996 88.5103L147.456 82.718L150.15 77.0364L153.04 71.4459L156.138 65.9726C157.212 64.1698 158.318 62.3931 159.425 60.6164C163.915 53.542 168.933 46.8126 174.419 40.5127C173.228 42.2308 172.011 43.9295 170.794 45.6216L167.306 50.8086L163.928 56.0607L160.681 61.3908L157.576 66.7991L154.622 72.2855L151.81 77.8434L149.181 83.486L146.708 89.2002L144.43 94.9924L142.334 100.856L140.44 106.792C138.071 114.751 136.23 122.886 135.117 131.171L135.11 131.178Z",
    fill: "#AAC8FD"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.264 93.4372C183.844 91.6669 186.785 85.712 183.713 82.2301C180.811 78.9435 175.194 81.0456 172.285 83.2519C169.695 85.2239 169.187 88.3933 165.517 88.9856C163.258 89.35 160.967 88.8099 158.703 88.4714C156.438 88.133 153.991 88.0224 151.999 89.1483C149.578 90.5085 148.407 93.333 147.704 96.0209C147.001 98.7088 146.539 101.566 144.912 103.811C142.68 106.89 138.814 108.113 135.43 109.942C130.223 112.76 127.62 118.155 129.527 123.98C130.789 127.826 133.763 130.95 137.258 132.987C140.753 135.024 144.756 136.046 148.758 136.632C151.433 137.022 154.251 137.211 156.75 136.189C161.514 134.25 160.922 129.603 161.41 125.373C161.664 123.147 161.944 120.856 163.057 118.917C165.51 114.621 171.511 112.916 173.079 108.224C173.88 105.822 173.287 103.206 173.411 100.681C173.626 96.1771 176.795 95.1553 180.277 93.4372H180.264Z",
    fill: "url(#paint2_linear_17594_63343)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.252 132.981C140.747 135.012 144.749 136.04 148.752 136.626C151.426 137.016 154.244 137.205 156.744 136.183C161.508 134.244 160.915 129.597 161.403 125.367C161.657 123.148 161.937 120.85 163.05 118.911C165.504 114.615 171.504 112.91 173.072 108.218C173.704 106.33 173.476 104.3 173.404 102.295C173.164 104.144 172.76 105.966 171.706 107.437C168.51 111.895 162.308 109.884 158.325 112.891C154.824 115.533 154.583 120.57 153.092 124.365C151.218 129.155 146.246 132.558 141.098 132.571C138.345 132.578 135.631 131.608 133.418 129.981C133.217 129.831 133.034 129.669 132.859 129.506C134.134 130.873 135.631 132.044 137.245 132.981H137.252Z",
    fill: "url(#paint3_linear_17594_63343)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.833 98.4287V98.4366L173.841 98.4287H173.833Z",
    fill: "url(#paint4_linear_17594_63343)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.044 129.597C141.554 124.761 143.708 120.114 146.305 115.734C146.975 114.654 147.645 113.567 148.335 112.493L150.528 109.356L152.884 106.343L155.377 103.434L158.026 100.668L160.792 98.0256L163.694 95.533C164.697 94.739 165.705 93.9645 166.721 93.1901C170.827 90.1768 175.24 87.58 179.906 85.6016C175.656 88.3545 171.576 91.2832 167.736 94.4852C166.799 95.3117 165.855 96.1318 164.898 96.9323L162.152 99.4769L159.49 102.106L156.939 104.84L154.466 107.645L152.11 110.554L149.845 113.535C149.142 114.563 148.413 115.578 147.684 116.6C144.879 120.739 142.361 125.087 140.044 129.59V129.597Z",
    fill: "#80A7FF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.054 21.8345H14.8048C7.97061 21.8345 2.43042 27.3747 2.43042 34.2088V124.598C2.43042 131.432 7.97061 136.972 14.8048 136.972H138.054C144.888 136.972 150.428 131.432 150.428 124.598V34.2088C150.428 27.3747 144.888 21.8345 138.054 21.8345Z",
    fill: "url(#paint5_linear_17594_63343)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0575 54.7915H12.3007C11.6159 54.7915 11.0608 55.3466 11.0608 56.0314V66.9228C11.0608 67.6075 11.6159 68.1626 12.3007 68.1626H27.0575C27.7423 68.1626 28.2974 67.6075 28.2974 66.9228V56.0314C28.2974 55.3466 27.7423 54.7915 27.0575 54.7915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9713 54.7915H31.2145C30.5297 54.7915 29.9746 55.3466 29.9746 56.0314V66.9228C29.9746 67.6075 30.5297 68.1626 31.2145 68.1626H45.9713C46.6561 68.1626 47.2112 67.6075 47.2112 66.9228V56.0314C47.2112 55.3466 46.6561 54.7915 45.9713 54.7915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8937 54.7915H50.1368C49.4521 54.7915 48.897 55.3466 48.897 56.0314V66.9228C48.897 67.6075 49.4521 68.1626 50.1368 68.1626H64.8937C65.5784 68.1626 66.1336 67.6075 66.1336 66.9228V56.0314C66.1336 55.3466 65.5784 54.7915 64.8937 54.7915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8075 54.7915H69.0507C68.3659 54.7915 67.8108 55.3466 67.8108 56.0314V66.9228C67.8108 67.6075 68.3659 68.1626 69.0507 68.1626H83.8075C84.4923 68.1626 85.0474 67.6075 85.0474 66.9228V56.0314C85.0474 55.3466 84.4923 54.7915 83.8075 54.7915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.722 54.7915H87.965C87.2802 54.7915 86.7251 55.3466 86.7251 56.0314V66.9228C86.7251 67.6075 87.2802 68.1626 87.965 68.1626H102.722C103.407 68.1626 103.962 67.6075 103.962 66.9228V56.0314C103.962 55.3466 103.407 54.7915 102.722 54.7915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.636 54.7915H106.879C106.194 54.7915 105.639 55.3466 105.639 56.0314V66.9228C105.639 67.6075 106.194 68.1626 106.879 68.1626H121.636C122.321 68.1626 122.876 67.6075 122.876 66.9228V56.0314C122.876 55.3466 122.321 54.7915 121.636 54.7915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.55 54.7915H125.793C125.108 54.7915 124.553 55.3466 124.553 56.0314V66.9228C124.553 67.6075 125.108 68.1626 125.793 68.1626H140.55C141.234 68.1626 141.79 67.6075 141.79 66.9228V56.0314C141.79 55.3466 141.234 54.7915 140.55 54.7915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0575 69.9453H12.3007C11.6159 69.9453 11.0608 70.5004 11.0608 71.1852V82.0766C11.0608 82.7613 11.6159 83.3164 12.3007 83.3164H27.0575C27.7423 83.3164 28.2974 82.7613 28.2974 82.0766V71.1852C28.2974 70.5004 27.7423 69.9453 27.0575 69.9453Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9713 69.9453H31.2145C30.5297 69.9453 29.9746 70.5004 29.9746 71.1852V82.0766C29.9746 82.7613 30.5297 83.3164 31.2145 83.3164H45.9713C46.6561 83.3164 47.2112 82.7613 47.2112 82.0766V71.1852C47.2112 70.5004 46.6561 69.9453 45.9713 69.9453Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8937 69.9453H50.1368C49.4521 69.9453 48.897 70.5004 48.897 71.1852V82.0766C48.897 82.7613 49.4521 83.3164 50.1368 83.3164H64.8937C65.5784 83.3164 66.1336 82.7613 66.1336 82.0766V71.1852C66.1336 70.5004 65.5784 69.9453 64.8937 69.9453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8075 69.9453H69.0507C68.3659 69.9453 67.8108 70.5004 67.8108 71.1852V82.0766C67.8108 82.7613 68.3659 83.3164 69.0507 83.3164H83.8075C84.4923 83.3164 85.0474 82.7613 85.0474 82.0766V71.1852C85.0474 70.5004 84.4923 69.9453 83.8075 69.9453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.722 69.9453H87.965C87.2802 69.9453 86.7251 70.5004 86.7251 71.1852V82.0766C86.7251 82.7613 87.2802 83.3164 87.965 83.3164H102.722C103.407 83.3164 103.962 82.7613 103.962 82.0766V71.1852C103.962 70.5004 103.407 69.9453 102.722 69.9453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.636 69.9453H106.879C106.194 69.9453 105.639 70.5004 105.639 71.1852V82.0766C105.639 82.7613 106.194 83.3164 106.879 83.3164H121.636C122.321 83.3164 122.876 82.7613 122.876 82.0766V71.1852C122.876 70.5004 122.321 69.9453 121.636 69.9453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.55 69.9453H125.793C125.108 69.9453 124.553 70.5004 124.553 71.1852V82.0766C124.553 82.7613 125.108 83.3164 125.793 83.3164H140.55C141.234 83.3164 141.79 82.7613 141.79 82.0766V71.1852C141.79 70.5004 141.234 69.9453 140.55 69.9453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0575 85.0908H12.3007C11.6159 85.0908 11.0608 85.6459 11.0608 86.3307V97.2221C11.0608 97.9068 11.6159 98.4619 12.3007 98.4619H27.0575C27.7423 98.4619 28.2974 97.9068 28.2974 97.2221V86.3307C28.2974 85.6459 27.7423 85.0908 27.0575 85.0908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9713 85.0908H31.2145C30.5297 85.0908 29.9746 85.6459 29.9746 86.3307V97.2221C29.9746 97.9068 30.5297 98.4619 31.2145 98.4619H45.9713C46.6561 98.4619 47.2112 97.9068 47.2112 97.2221V86.3307C47.2112 85.6459 46.6561 85.0908 45.9713 85.0908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8937 85.0908H50.1368C49.4521 85.0908 48.897 85.6459 48.897 86.3307V97.2221C48.897 97.9068 49.4521 98.4619 50.1368 98.4619H64.8937C65.5784 98.4619 66.1336 97.9068 66.1336 97.2221V86.3307C66.1336 85.6459 65.5784 85.0908 64.8937 85.0908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8075 85.0908H69.0507C68.3659 85.0908 67.8108 85.6459 67.8108 86.3307V97.2221C67.8108 97.9068 68.3659 98.4619 69.0507 98.4619H83.8075C84.4923 98.4619 85.0474 97.9068 85.0474 97.2221V86.3307C85.0474 85.6459 84.4923 85.0908 83.8075 85.0908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.722 85.0908H87.965C87.2802 85.0908 86.7251 85.6459 86.7251 86.3307V97.2221C86.7251 97.9068 87.2802 98.4619 87.965 98.4619H102.722C103.407 98.4619 103.962 97.9068 103.962 97.2221V86.3307C103.962 85.6459 103.407 85.0908 102.722 85.0908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M121.636 85.0908H106.879C106.194 85.0908 105.639 85.6459 105.639 86.3307V97.2221C105.639 97.9068 106.194 98.4619 106.879 98.4619H121.636C122.321 98.4619 122.876 97.9068 122.876 97.2221V86.3307C122.876 85.6459 122.321 85.0908 121.636 85.0908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M140.55 85.0908H125.793C125.108 85.0908 124.553 85.6459 124.553 86.3307V97.2221C124.553 97.9068 125.108 98.4619 125.793 98.4619H140.55C141.234 98.4619 141.79 97.9068 141.79 97.2221V86.3307C141.79 85.6459 141.234 85.0908 140.55 85.0908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0575 100.237H12.3007C11.6159 100.237 11.0608 100.792 11.0608 101.477V112.368C11.0608 113.053 11.6159 113.608 12.3007 113.608H27.0575C27.7423 113.608 28.2974 113.053 28.2974 112.368V101.477C28.2974 100.792 27.7423 100.237 27.0575 100.237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9713 100.237H31.2145C30.5297 100.237 29.9746 100.792 29.9746 101.477V112.368C29.9746 113.053 30.5297 113.608 31.2145 113.608H45.9713C46.6561 113.608 47.2112 113.053 47.2112 112.368V101.477C47.2112 100.792 46.6561 100.237 45.9713 100.237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8937 100.237H50.1368C49.4521 100.237 48.897 100.792 48.897 101.477V112.368C48.897 113.053 49.4521 113.608 50.1368 113.608H64.8937C65.5784 113.608 66.1336 113.053 66.1336 112.368V101.477C66.1336 100.792 65.5784 100.237 64.8937 100.237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8075 100.237H69.0507C68.3659 100.237 67.8108 100.792 67.8108 101.477V112.368C67.8108 113.053 68.3659 113.608 69.0507 113.608H83.8075C84.4923 113.608 85.0474 113.053 85.0474 112.368V101.477C85.0474 100.792 84.4923 100.237 83.8075 100.237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.722 100.237H87.965C87.2802 100.237 86.7251 100.792 86.7251 101.477V112.368C86.7251 113.053 87.2802 113.608 87.965 113.608H102.722C103.407 113.608 103.962 113.053 103.962 112.368V101.477C103.962 100.792 103.407 100.237 102.722 100.237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.636 100.237H106.879C106.194 100.237 105.639 100.792 105.639 101.477V112.368C105.639 113.053 106.194 113.608 106.879 113.608H121.636C122.321 113.608 122.876 113.053 122.876 112.368V101.477C122.876 100.792 122.321 100.237 121.636 100.237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.55 100.237H125.793C125.108 100.237 124.553 100.792 124.553 101.477V112.368C124.553 113.053 125.108 113.608 125.793 113.608H140.55C141.234 113.608 141.79 113.053 141.79 112.368V101.477C141.79 100.792 141.234 100.237 140.55 100.237Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0575 115.392H12.3007C11.6159 115.392 11.0608 115.947 11.0608 116.631V127.523C11.0608 128.208 11.6159 128.763 12.3007 128.763H27.0575C27.7423 128.763 28.2974 128.208 28.2974 127.523V116.631C28.2974 115.947 27.7423 115.392 27.0575 115.392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9713 115.392H31.2145C30.5297 115.392 29.9746 115.947 29.9746 116.631V127.523C29.9746 128.208 30.5297 128.763 31.2145 128.763H45.9713C46.6561 128.763 47.2112 128.208 47.2112 127.523V116.631C47.2112 115.947 46.6561 115.392 45.9713 115.392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8937 115.392H50.1368C49.4521 115.392 48.897 115.947 48.897 116.631V127.523C48.897 128.208 49.4521 128.763 50.1368 128.763H64.8937C65.5784 128.763 66.1336 128.208 66.1336 127.523V116.631C66.1336 115.947 65.5784 115.392 64.8937 115.392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8075 115.392H69.0507C68.3659 115.392 67.8108 115.947 67.8108 116.631V127.523C67.8108 128.208 68.3659 128.763 69.0507 128.763H83.8075C84.4923 128.763 85.0474 128.208 85.0474 127.523V116.631C85.0474 115.947 84.4923 115.392 83.8075 115.392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.722 115.392H87.965C87.2802 115.392 86.7251 115.947 86.7251 116.631V127.523C86.7251 128.208 87.2802 128.763 87.965 128.763H102.722C103.407 128.763 103.962 128.208 103.962 127.523V116.631C103.962 115.947 103.407 115.392 102.722 115.392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M121.636 115.392H106.879C106.194 115.392 105.639 115.947 105.639 116.631V127.523C105.639 128.208 106.194 128.763 106.879 128.763H121.636C122.321 128.763 122.876 128.208 122.876 127.523V116.631C122.876 115.947 122.321 115.392 121.636 115.392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.55 115.392H125.793C125.108 115.392 124.553 115.947 124.553 116.631V127.523C124.553 128.208 125.108 128.763 125.793 128.763H140.55C141.234 128.763 141.79 128.208 141.79 127.523V116.631C141.79 115.947 141.234 115.392 140.55 115.392Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127.026 34.014C127.026 35.0432 126.191 35.886 125.154 35.886C124.116 35.886 123.282 35.0513 123.282 34.014C123.282 32.9768 124.116 32.1421 125.154 32.1421C126.191 32.1421 127.026 32.9768 127.026 34.014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M134.408 34.014C134.408 35.0432 133.574 35.886 132.536 35.886C131.499 35.886 130.664 35.0513 130.664 34.014C130.664 32.9768 131.499 32.1421 132.536 32.1421C133.574 32.1421 134.408 32.9768 134.408 34.014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M141.791 34.014C141.791 35.0432 140.956 35.886 139.919 35.886C138.882 35.886 138.047 35.0513 138.047 34.014C138.047 32.9768 138.882 32.1421 139.919 32.1421C140.956 32.1421 141.791 32.9768 141.791 34.014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.9
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5364 34.0139C17.5364 35.8049 16.0859 37.2554 14.2949 37.2554C12.504 37.2554 11.0535 35.8049 11.0535 34.0139C11.0535 32.223 12.504 30.7725 14.2949 30.7725C16.0859 30.7725 17.5364 32.223 17.5364 34.0139Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17594_63343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0416 28.8032C37.0416 30.6994 35.5019 32.2391 33.6056 32.2391C31.7094 32.2391 30.1697 30.6994 30.1697 28.8032C30.1697 26.9069 31.7094 25.3672 33.6056 25.3672C35.5019 25.3672 37.0416 26.9069 37.0416 28.8032Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17594_63343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1888 28.8032C54.1888 30.6994 52.6491 32.2391 50.7529 32.2391C48.8566 32.2391 47.3169 30.6994 47.3169 28.8032C47.3169 26.9069 48.8566 25.3672 50.7529 25.3672C52.6491 25.3672 54.1888 26.9069 54.1888 28.8032Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_17594_63343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2714 28.8032C71.2714 30.6994 69.7317 32.2391 67.8354 32.2391C65.9391 32.2391 64.3994 30.6994 64.3994 28.8032C64.3994 26.9069 65.9391 25.3672 67.8354 25.3672C69.7317 25.3672 71.2714 26.9069 71.2714 28.8032Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_17594_63343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4108 28.8032C88.4108 30.6994 86.8711 32.2391 84.9748 32.2391C83.0785 32.2391 81.5388 30.6994 81.5388 28.8032C81.5388 26.9069 83.0785 25.3672 84.9748 25.3672C86.8711 25.3672 88.4108 26.9069 88.4108 28.8032Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_17594_63343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.558 28.8032C105.558 30.6994 104.018 32.2391 102.122 32.2391C100.226 32.2391 98.686 30.6994 98.686 28.8032C98.686 26.9069 100.226 25.3672 102.122 25.3672C104.018 25.3672 105.558 26.9069 105.558 28.8032Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_17594_63343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.706 28.8032C122.706 30.6994 121.166 32.2391 119.27 32.2391C117.373 32.2391 115.834 30.6994 115.834 28.8032C115.834 26.9069 117.373 25.3672 119.27 25.3672C121.166 25.3672 122.706 26.9069 122.706 28.8032Z",
    fill: "white"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5887 28.803C32.5109 28.803 31.6438 27.9278 31.6438 26.8581V13.9732C31.6438 12.8954 32.519 12.0283 33.5887 12.0283C34.6665 12.0283 35.5336 12.9035 35.5336 13.9732V26.8581C35.5336 27.9359 34.6584 28.803 33.5887 28.803Z",
    fill: "#5857A3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7203 28.803C49.6425 28.803 48.7754 27.9278 48.7754 26.8581V13.9732C48.7754 12.8954 49.6506 12.0283 50.7203 12.0283C51.7981 12.0283 52.6652 12.9035 52.6652 13.9732V26.8581C52.6652 27.9359 51.79 28.803 50.7203 28.803Z",
    fill: "#5857A3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8592 28.803C66.7814 28.803 65.9143 27.9278 65.9143 26.8581V13.9732C65.9143 12.8954 66.7895 12.0283 67.8592 12.0283C68.937 12.0283 69.8041 12.9035 69.8041 13.9732V26.8581C69.8041 27.9359 68.9289 28.803 67.8592 28.803Z",
    fill: "#5857A3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9986 28.803C83.9208 28.803 83.0537 27.9278 83.0537 26.8581V13.9732C83.0537 12.8954 83.9289 12.0283 84.9986 12.0283C86.0764 12.0283 86.9435 12.9035 86.9435 13.9732V26.8581C86.9435 27.9359 86.0683 28.803 84.9986 28.803Z",
    fill: "#5857A3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M102.13 28.803C101.052 28.803 100.185 27.9278 100.185 26.8581V13.9732C100.185 12.8954 101.06 12.0283 102.13 12.0283C103.208 12.0283 104.075 12.9035 104.075 13.9732V26.8581C104.075 27.9359 103.199 28.803 102.13 28.803Z",
    fill: "#5857A3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M119.269 28.803C118.192 28.803 117.324 27.9278 117.324 26.8581V13.9732C117.324 12.8954 118.2 12.0283 119.269 12.0283C120.347 12.0283 121.214 12.9035 121.214 13.9732V26.8581C121.214 27.9359 120.339 28.803 119.269 28.803Z",
    fill: "#5857A3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17594_63343",
    x: 0.169678,
    y: 0.367188,
    width: 66.8718,
    height: 66.8721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.301961 0 0 0 0 0.556863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17594_63343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17594_63343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17594_63343",
    x: 17.3169,
    y: 0.367188,
    width: 66.8718,
    height: 66.8721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.301961 0 0 0 0 0.556863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17594_63343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17594_63343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_17594_63343",
    x: 34.3994,
    y: 0.367188,
    width: 66.8718,
    height: 66.8721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.301961 0 0 0 0 0.556863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17594_63343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17594_63343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_17594_63343",
    x: 51.5388,
    y: 0.367188,
    width: 66.8718,
    height: 66.8721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.301961 0 0 0 0 0.556863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17594_63343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17594_63343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_17594_63343",
    x: 68.686,
    y: 0.367188,
    width: 66.8718,
    height: 66.8721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.301961 0 0 0 0 0.556863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17594_63343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17594_63343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_17594_63343",
    x: 85.8337,
    y: 0.367188,
    width: 66.8721,
    height: 66.8721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.301961 0 0 0 0 0.556863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17594_63343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17594_63343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17594_63343",
    x1: 147.899,
    y1: 136.163,
    x2: 147.899,
    y2: 34.9544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17594_63343",
    x1: 150.476,
    y1: 62.0811,
    x2: 179.613,
    y2: 124.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C2D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17594_63343",
    x1: 161.133,
    y1: 135.967,
    x2: 154.463,
    y2: 83.6812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17594_63343",
    x1: 155.781,
    y1: 136.65,
    x2: 151.753,
    y2: 105.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17594_63343",
    x1: 173.838,
    y1: 98.4559,
    x2: 173.837,
    y2: 98.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17594_63343",
    x1: 76.4254,
    y1: 136.972,
    x2: 76.4254,
    y2: 21.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546CFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSvg);
export default __webpack_public_path__ + "static/media/CalendarSVG.31d85235d5524acf29d2db6071ce8f1d.svg";
export { ForwardRef as ReactComponent };